/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useClusterSelection } from 'App/Pages/Project/IdpApplication/hooks';

import { ClusterSelection } from './../cluster-selection';
import SettingsModalCommon from './SettingsModal.common';

export const SettingsModal = ({ isOpen, onClose, clusterId }) => {
  // @ts-expect-error TS2345
  const { clusters, selectedCluster, setSelectedCluster } = useClusterSelection({ clusterId });

  return (
    <SettingsModalCommon
      variant="sm"
      isOpen={isOpen}
      onClose={onClose}
      clusters={clusters}
      modalContentExtensionSection={<ClusterSelection cluster={selectedCluster} setCluster={setSelectedCluster} />}
      getAdditionalParametersWhenFinalizingCreation={() => [selectedCluster?.id]}
    />
  );
};
